const doc = [({"da":({"js":({"components":({"modal":({"go_back":"Gå tilbage"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;